import { Ticket } from "./Entity";

export class Loan extends Ticket {
  constructor() {
    super();
  }

  portfolioName: string = null;
  portfolioDocument: string = null;
  portfolioBank: string = null;
  portfolioBranch: string = null;
  portfolioAccount: string = null;
  portfolioCode: string = null;
  portfolioClearingAccount: string = null;
  portfolioFundId: number = null;
  portfolioFundAccountId: number = null;

  typeAction: number = null;
  broker: string = null;
  clearingAgent: string = null;
  loanType: string = null;
  loanOperationTypeId: number = null;
  isReversibleByDonor: boolean = null;
  dueDate: Date;
  settlementDate: Date = null;
  contractNumber: string = null;
  paperCode: string = null;
  stocksAmount: number = null;
  finalGraceDate?: Date;
  remunerationRate?: number = null;
  commissionFee?: number = null;
  settlementPeriodicity;
  operationCode: string = null;
  marginCredit: boolean = null;
  priceSettlementReference: number = null;

  annotations: string = null;
}
